<template>
    <b-alert show variant="warning" v-if="show">
        There are invoices with a reopened status. Until these are posted, you
        may have difficulty reconciling, as any balances, payments, and
        overpayment credits may not yet settled.<br />Please
        <a
            href="/view/billing/dashboard?tab=tab-invoices&list=6"
            target="_blank"
        >
            click here
        </a>
        to see the list of invoices with a reopened status. Once the invoices
        are posted, please
        <a @click.prevent="$emit('refresh')" href="#">refresh</a> the report to
        see any updates.
    </b-alert>
</template>

<script>
export default {
    props: {
        show: {
            default: false,
            type: Boolean
        }
    }
};
</script>
